import React from "react";

class TitleBar extends React.Component {
  render() {
    const { small } = this.props;
    return (
      <div className="TitleBar">
        <p style={small ? { fontSize: "18px" } : {}}>{this.props.title}</p>
        {this.props.children}
      </div>
    );
  }
}

export default TitleBar;



// WEBPACK FOOTER //
// ./src/components/TitleBar.js